import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { campaignsApiPath } from './apiPath';

const RejectSeedingProposalRequestSchema = z
  .object({
    participationId: z.number().int(),
    /** 거절 사유 코드 — GET rejection-reasons 응답의 code 값(1개 이상). */
    rejectionReasonCodes: z.array(z.string().min(1)).min(1),
  })
  .describe('RejectSeedingProposalRequest');

export type RejectSeedingProposalRequest = z.infer<typeof RejectSeedingProposalRequestSchema>;

// NOTE: 204 No Content (성공). 응답 본문이 없으므로 unknown 으로 통과시킨다.
const RejectSeedingProposalResponseSchema = z.unknown().describe('RejectSeedingProposalResponse');

export type RejectSeedingProposalResponse = z.infer<typeof RejectSeedingProposalResponseSchema>;

export const rejectSeedingProposal = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(RejectSeedingProposalRequestSchema),
    async ({
      participationId,
      rejectionReasonCodes,
    }: RejectSeedingProposalRequest): Promise<RejectSeedingProposalResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.post<RejectSeedingProposalResponse>(
          urlJoin(campaignsApiPath.rejectSeedingProposal(participationId)),
          { rejectionReasonCodes },
          // 204 No Content 성공 응답의 빈 본문을 JSON 파싱하다 브라우저 fetch 어댑터가
          // throw → 거절 성공인데 실패 토스트가 뜨던 문제 방지. (SID-4053)
          { responseType: 'text' },
        ),
      ),
    validateApiResponse(RejectSeedingProposalResponseSchema),
  ),
);
